
let initialState = {
    api: ''
};

const OfflineDonationReducer = (state = initialState, action) => {
    return state;
}

export default OfflineDonationReducer;